import { Div, router } from '@codesuma/baseline'
import { HomePage } from './pages/home'
import { AddPage } from './pages/add'
import { ListPage } from './pages/list'
import { LoginPage } from './pages/login'
import { MenuPage } from './pages/menu'
import { AboutPage } from './pages/about'
import { DiscoverPage } from './pages/discover'
import { PublicListPage } from './pages/public-list'
import style from './app.module.css'

export const App = () => {
    // Base container
    const base = Div()
    base.addClass(style.base)

    // View
    const view = Div()
    view.addClass(style.view)
    base.append(view)

    // The SPA owns the root on both web and native. The marketing landing lives
    // at the static /about page (served by the server, web only).
    const routes = {
        '/': HomePage,
        '/add': AddPage,
        '/list/:id': ListPage,
        '/login': LoginPage,
        '/menu': MenuPage,
        '/about': AboutPage,
        '/discover': DiscoverPage,
        '/l/:slug': PublicListPage,
    }
    router.routes(routes, view)

    return base
}